module.exports = __webpack_public_path__ + "media/images/games/35gender/purple-bab14ba1a598d430fc7e149ce0ed2e8b.png";